import Bookshelf from './Bookshelf.jsx';
import BookHighlight from './BookHighlight.jsx';
import Loading from './Loading.jsx';

// The classic theme: the bookshelf a room has.
//
// Two panels the carousel pages between - the shelf itself, and a full-bleed
// page-turn through one shelf's books. `focus` carries which book the second
// should open on; `goToPanel` takes a key from this theme's own panel list, so
// a theme never has to know what else is loaded beside it.
export default {
  id: 'classic',
  label: 'Classic shelf',

  // What the display shows while the books load - see Loading.jsx.
  Loading,

  panels: [
    {
      key: 'shelf',
      Component: ({ data, settings, setFocus, goToPanel }) => (
        <div className="mode-inner">
          <Bookshelf
            books={data}
            settings={settings}
            onSelect={(shelfKey, bookId) => {
              setFocus({ shelfKey, bookId });
              goToPanel('highlight');
            }}
          />
        </div>
      ),
    },
    {
      key: 'highlight',
      Component: ({ data, settings, active, focus, goToPanel }) => (
        <BookHighlight
          books={data}
          settings={settings}
          active={active}
          seed={focus}
          onExit={() => goToPanel('shelf')}
        />
      ),
    },
  ],
};
